import { useState, useEffect } from 'react'
import { toastError, toastSuccess } from '../../util/toastUtil'
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useCustomAxios } from '../../axiosInstance'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader
import '../Login/login.css'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import { ResetPasswordContext } from './index'
import OtpInput from 'react-otp-input'
import MuiInput from '../../components/MaterialComponent/MuiInput'
import MuiButton from '../../components/MaterialComponent/MuiButton'
import './Otp.css'
import { useContext } from 'react'
import { RESETPASSWORD_ENDPOINTS } from '../../constants/apiConstants'

const Otp = ({ setCurrentStep, STEP, handleOtp, setLoadingData }) => {
    const axios = useCustomAxios()
    const navigate = useNavigate()
    const [otp, setOtp] = useState('')
    const [contextData, setContextData] = useContext(ResetPasswordContext)
    const [timer, setTimer] = useState(60) // Initial timer value in seconds
    const [isTimerRunning, setIsTimerRunning] = useState(true)

    useEffect(() => {
        let countdown

        if (isTimerRunning && timer > 0) {
            countdown = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1)
            }, 1000)
        }

        if (timer === 0) {
            setIsTimerRunning(false)
            clearInterval(countdown)
        }

        return () => {
            clearInterval(countdown)
        }
    }, [isTimerRunning, timer])

    const handleResendClick = () => {
        if (!isTimerRunning) {
            setTimer(60) // Reset the timer to 60 seconds
            setIsTimerRunning(true)
        }
        handleOtp({ ...contextData })
    }

    const handleOtpSubmit = async (e) => {
        e.preventDefault()

        if (!otp) {
            toastError('Please enter the otp')
            return
        }

        const { selectedOption, otpNumberDetails, userDetails } = contextData
        const { email, userId } = userDetails

        const isPhoneNumberOption = selectedOption === 'phone_number'
        const url = isPhoneNumberOption
            ? RESETPASSWORD_ENDPOINTS.VERIFYTELESIGNOTP
            : RESETPASSWORD_ENDPOINTS.VERIFYEMAILSECURITYCODE
        const data = isPhoneNumberOption
            ? {
                  referenceId: otpNumberDetails.reference_id,
                  clientVerifyCode: otp,
              }
            : { email, code: otp }

        const options = {
            headers: { 'content-type': 'application/json' },
        }

        try {
            setLoadingData(true)
            const response = await axios.post(url, data, options)
            // console.log('telesign response', response)
            if (response.status === 200) {
                toastSuccess(response.data.message)
                setCurrentStep(STEP.step4)
            } else {
                toastError('Otp Verification Failed, Please try again')
            }
            setLoadingData(false)
        } catch (error) {
            // console.error('An error occurred during OTP verification:', error)
            setLoadingData(false)
            toastError(
                error.response.data
                    ? error.response.data
                    : 'Something went wrong, please try again.'
            )
        }
    }

    return (
        <>
            <form
                className="form"
                style={{ maxWidth: '600px', minWidth: '550px' }}
                onSubmit={handleOtpSubmit}>
                <h5>Reset Forgotten Password</h5>
                {/* <h6 style={{ fontWeight: 'bold' }}>Select the method of sending a one time passcode </h6> */}
                <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">
                        Enter the one time passcode below. the code will expire
                        after 10 minutes.
                    </FormLabel>
                    {contextData?.selectedOption === 'phone_number' ? (
                        <OtpInput
                            value={otp}
                            onChange={(value) => setOtp(value)}
                            numInputs={5}
                            renderSeparator={<span>-</span>}
                            renderInput={(props) => <input {...props} />}
                            inputStyle={{
                                height: '45px',
                                width: '50px',
                                fontSize: '1.5rem',
                                color: 'rgb(33, 150, 243)',
                                margin: '0px 5px',
                            }}
                            containerStyle={{
                                justifyContent: 'center',
                                margin: '10px 0px',
                                fontSize: '10px',
                            }}
                        />
                    ) : (
                        <MuiInput
                            required
                            id="otp"
                            label="Enter OTP"
                            name="id"
                            onChange={(e) => setOtp(e.target.value)}
                            value={otp}
                            // type="number"
                        />
                    )}

                    <div className="resend-otp-container">
                        <label
                            className={
                                isTimerRunning
                                    ? 'resend-otp-label disabled'
                                    : 'resend-otp-label'
                            }
                            onClick={handleResendClick}>
                            Resend OTP?
                        </label>
                        <p className="timer">Time remaining: {timer} seconds</p>
                    </div>
                </FormControl>

                <MuiButton>Reset Password</MuiButton>
            </form>
        </>
    )
}
export default Otp
